import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { StyledFooter } from '../../../styles/StyledFooter';
import LogoImage from '../../../static/group_image/yageo-group-logo-white.png';

import './foot_style.css';
import FooterTerms from './FooterTerms';
import { useFooterContent } from '../../../graphql/pimcore/modules/siteContent/hooks/useFooterContent';
import { useLocale } from '../../../contexts/LocaleProvider';
import { formatIcuString } from '../../../utils/Locale';
import ImageLink from '../../common/ImageLink';
import Image from 'next/image';

interface FooterProps {}

const Footer: FunctionComponent<FooterProps> = () => {
    const intl = useIntl();
    const { loading, contentTree } = useFooterContent();
    const { locale } = useLocale();
    const cmsContent = contentTree.bottom;

    if (loading) {
        return null;
    }
    return (
        <StyledFooter component="footer" style={{ backgroundColor: '#191a1b' }}>
            <div className="footer-section">
                <div className="flex-row  items-center footer-logos">
                    <Link to="/" aria-label={'Go to homepage'}>
                        <Image
                            className="image_11"
                            src={LogoImage}
                            alt={intl.formatMessage({
                                id: 'YAGEO Group logo',
                                defaultMessage: 'YAGEO Group logo',
                            })}
                        />
                    </Link>
                    <div className="flex-col">
                        <span className="self-start font_3" role="heading" aria-level={2}>
                            {cmsContent.connect.title.content}:
                        </span>
                        <nav aria-labelledby="footer-connect-heading" aria-label="Connect links">
                            <div className="mt-10 flex-row self-stretch" role="list">
                                {contentTree.bottom.connect.links.links.map((link, idx) => (
                                    <ImageLink key={idx} link={link} className="ml-14 image_13" />
                                ))}
                            </div>
                        </nav>
                    </div>
                </div>
                <div className="flex-row mt-yageo-group responsive-layout">
                    <div className="yageo-group">
                        <span className="font_13 text_40 no-wrap" style={{ marginRight: '0.5em' }}>
                            {formatIcuString(
                                cmsContent.copyrightNotice.copyright.content,
                                { year: new Date().getFullYear() },
                                locale
                            )}
                        </span>
                        <div className="break-after-left">
                            <span className="font_13 text_40 no-wrap">
                                {cmsContent.copyrightNotice.rightsNotice.content}
                            </span>
                        </div>
                    </div>
                    <FooterTerms links={cmsContent.links} />
                </div>
            </div>
        </StyledFooter>
    );
};

export default Footer;
